/**
 * Converts a UTC time string (HH:MM) to the user's local time string.
 * Defaults to 00:00 (daily reset time).
 */
export function getLocalResetTime(utcHour = 0, utcMinute = 0) {
  try {
    const now = new Date();
    const utcDate = new Date(Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      utcHour,
      utcMinute
    ));

    return utcDate.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (e) {
    return '00:00';
  }
}
